module.exports = __webpack_public_path__ + "static/media/chicagoRiverBlur.2bb81c64.jpg";